import axios from 'axios';

const baseURLProd = 'https://read-mate-server.onrender.com/api'; // Replace with your actual base URL
const baseURLDev = 'http://localhost:3001/api'; // Replace with your actual base URL

const instance = axios.create({
    baseURL: baseURLDev,
});




const updateAuthorizationHeader = (token) => {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// instance.interceptors.response.use((response) => {
//     // Handle successful responses
//     return response;
// }, (error) => {
//     // Handle error responses
//     if (error.response) {
//         // The server responded with a status code outside the range of 2xx
//         console.error(error.response.data);
//         console.error(error.response.status);
//         console.error(error.response.headers);
//     } else if (error.request) {
//         // The request was made, but no response was received
//         console.error(error.request);
//     } else {
//         // Something happened in setting up the request that triggered an error
//         console.error('Error', error.message);
//     }
//     return Promise.reject(error);
// });

export { instance, updateAuthorizationHeader };
